<template>
  <a-row :gutter="[16, 16]" :style="{ marginTop: '50px' }">
    <a-col :span="24" :style="{ padding: '12px', height: '50px', fontSize: '25px', fontWeight: '400', color: 'white', backgroundColor: '#4c7be3' }">
      机动车所有人身份
      <span @dblclick="handleDoubleClick">校验</span>
    </a-col>

    <!-- 规则设置弹窗 -->
    <a-modal
      :style="{ height: '700px', overflowY: 'auto' }"
      title="规则设置"
      :width="1000"
      :visible="isShowProvince"
      @ok="handleModalOk"
      @cancel="handleModalCancel"
    >
      <div :gutter="[16, 16]">
        <a-form id="AntibodyModal">
          <!-- 基础设置 -->
          <div class="setting-section">
            <div class="section-title">基础设置</div>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="特殊号牌数量">
                  <a-select :placeholder="''" :show-search="true" @change="specialNumsChange">
                    <a-select-option v-for="num in specialNums" :key="num" :value="num">
                      {{ num }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="车主姓名">
                  <a-input v-model="userName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="车辆品牌">
                  <a-input v-model="carBrand" placeholder="ex:奔驰、宝马" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="固定号牌">
                  <a-input v-model="fixedPlate" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <!-- 区域号设置 -->
          <div class="setting-section">
            <div class="section-title">区域号设置</div>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                  <div :style="{ border: '1px solid #d9d9d9', padding: '10px', borderRadius: '4px' }">
                    <div :style="{ marginBottom: '10px' }">
                      <a-checkbox-group v-model="selectedAreas" :style="{ width: '100%' }">
                        <a-row>
                          <a-col :span="4" v-for="area in areaes" :key="area">
                            <a-checkbox :value="area">{{ area }}</a-checkbox>
                          </a-col>
                        </a-row>
                      </a-checkbox-group>
                    </div>
                    <div :style="{ marginTop: '10px' }">
                      <div v-for="area in selectedAreas" :key="area" :style="{ marginBottom: '10px' }">
                        <span>区域 {{ area }} 的概率：</span>
                        <a-input-number
                          :style="{ width: '100px' }"
                          :min="1"
                          :max="100"
                          :value="areaProbabilities[area]"
                          @change="(value) => handleAreaProbabilityChange(area, value)"
                        />
                        <span :style="{ marginLeft: '5px' }">%</span>
                      </div>
                    </div>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <!-- 固定位置规则设置 -->
          <div class="setting-section">
            <div class="section-title">固定位置规则设置（字母和数字）</div>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                  <div :style="{ border: '1px solid #d9d9d9', padding: '10px', borderRadius: '4px' }">
                    <div :style="{ marginBottom: '10px' }">
                      <span>当前规则设置：</span>
                      <div :style="{ marginBottom: '10px' }">
                        <a-radio-group v-model="currentRule.type" @change="handleTypeChange">
                          <a-radio value="oil">油车</a-radio>
                          <a-radio value="new">新能源</a-radio>
                        </a-radio-group>
                      </div>
                      <div :style="{ display: 'flex', gap: '8px', margin: '10px 0' }">
                        <a-input
                          v-for="(pos, index) in currentRule.positions"
                          :key="index"
                          :style="{ width: '60px' }"
                          :placeholder="'位置' + (index + 1)"
                          :maxLength="1"
                          :value="pos"
                          @change="handleLetterChange"
                          @input="(e) => handlePositionInput(index, e.target.value)"
                        />
                      </div>
                      <div :style="{ marginTop: '10px' }">
                        <span>规则概率：</span>
                        <a-input-number
                          :style="{ width: '100px' }"
                          :min="1"
                          :max="100"
                          :value="currentRule.probability"
                          @change="handleProbabilityChange"
                        />
                        <span :style="{ marginLeft: '5px' }">%</span>
                        <a-button :style="{ marginLeft: '20px' }" type="primary" @click="addRule">
                          添加规则
                        </a-button>
                      </div>
                    </div>
                    <a-divider :style="{ margin: '10px 0' }" />
                    <div v-if="letterRules.length > 0">
                      <div :style="{ marginTop: '10px', fontWeight: 'bold' }">已添加的规则：</div>
                      <div
                        v-for="(rule, index) in letterRules"
                        :key="index"
                        :style="{ marginTop: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px', backgroundColor: '#f5f5f5', borderRadius: '4px' }"
                      >
                        <span>
                          规则{{ index + 1 }}:
                          <a-tag :color="rule.type === 'new' ? 'green' : 'blue'">
                            {{ rule.type === 'new' ? '新能源' : '油车' }}
                          </a-tag>
                          <span
                            v-for="(pos, i) in rule.positions"
                            :key="i"
                            :style="{ margin: '0 2px', display: 'inline-block', width: '20px', textAlign: 'center', backgroundColor: 'white', borderRadius: '2px' }"
                          >
                            {{ pos || '_' }}
                          </span>
                          ({{ rule.probability }}%)
                        </span>
                        <a-button :style="{ color: 'red' }" type="link" @click="removeRule(index)">
                          删除
                        </a-button>
                      </div>
                    </div>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </a-form>
      </div>
    </a-modal>

    <a-col :span="4"></a-col>
    <a-col :span="16" :style="{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50px', marginTop: '50px' }">
      <span :style="{ fontSize: '25px' }">机动车所有人身份证明号码后6位：</span>
      <span :style="{ fontSize: '35px', fontWeight: '400' }">{{ idCardLastSix }}</span>
    </a-col>
    <a-col :span="4"></a-col>
    <a-divider :style="{ height: '1px' }" />
    <a-col :span="4"></a-col>
    <a-col :span="16" :style="{ fontSize: '18px', fontWeight: '500', color: 'rgb(204, 17, 17)', textAlign: 'center' }">
      <span>请输入身份证号码后六位数字和字母部分(非汉字或特殊字符)！</span>
    </a-col>
    <a-col :span="4"></a-col>
    <a-divider :style="{ height: '1px' }" />

    <!-- 键盘 -->
    <div class="keyboard">
      <div class="keyboard-row">
        <a-button @click="handleInput('7')">7</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('8')">8</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('9')">9</a-button>
        <a-divider type="vertical" />
        <a-button :style="{ width: '280px', color: '#40a9ff' }" @click="toggleLetters">
          {{ isLetterMode ? '切换数字' : '切换字母' }}
        </a-button>
      </div>
      <div class="keyboard-row">
        <a-button @click="handleInput('4')">4</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('5')">5</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('6')">6</a-button>
        <a-divider type="vertical" />
        <a-button :style="{ width: '280px', color: '#40a9ff' }" @click="handleClear">清空</a-button>
      </div>
      <div class="keyboard-row">
        <a-button @click="handleInput('1')">1</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('2')">2</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('3')">3</a-button>
        <a-divider type="vertical" />
        <a-button :style="{ width: '280px', color: '#40a9ff' }" @click="handleBackspace">退格</a-button>
      </div>
      <div class="keyboard-row">
        <a-button @click="handleInput('0')">0</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleInput('X')">X</a-button>
        <a-divider type="vertical" />
        <a-button :style="{ width: '425px', color: 'rgb(218, 78, 78)' }" type="primary" @click="handleConfirm">确定</a-button>
      </div>
    </div>

    <div class="footer-buttons">
      <a-button type="danger" ghost @click="handleExit">退出系统</a-button>
      <a-button :style="{ backgroundColor: '#24b43c', color: '#ffffff', width: '200px', marginLeft: '10px' }" type="success" @click="handleConfirm">确认</a-button>
    </div>
  </a-row>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      visible: true,
      idCardLastSix: '',
      isLetterMode: false,
      provinces: ['京', '沪', '粤', '津', '渝', '冀', '豫', '云', '辽', '黑', '湘', '皖', '鲁', '新', '苏', '浙', '赣', '鄂', '桂', '甘', '晋', '蒙', '陕', '吉', '闽', '贵', '青', '藏', '川', '宁', '琼'],
      areaes: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      zimuNums: [0, 1, 2, 3, 4, 5],
      specialNums: Array.from({ length: 21 }, (_, i) => i),
      isShowProvince: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      currentRule: {
        positions: ['', '', '', '', ''],
        probability: 20,
        type: ''
      },
      selectedAreas: ['A'],
      areaProbabilities: { A: 20 }
    }
  },
  computed: {
    letterRules () {
      return this.$store.state.letterRules
    },
    userName: {
      get () {
        return this.$store.state.userName
      },
      set (value) {
        this.$store.commit('updateUserName', value)
      }
    },
    carBrand: {
      get () {
        return this.$store.state.carBrand
      },
      set (value) {
        this.$store.commit('updateCarBrand', value)
      }
    },
    fixedPlate: {
      get () {
        return this.$store.state.fixedPlate
      },
      set (value) {
        this.$store.commit('updateFixedPlate', value)
      }
    }
  },
  methods: {
    handleInput (char) {
      if (this.idCardLastSix.length < 6) {
        this.idCardLastSix += char
      }
    },
    handleBackspace () {
      this.idCardLastSix = this.idCardLastSix.slice(0, -1)
    },
    handleClear () {
      this.idCardLastSix = ''
    },
    toggleLetters () {
      this.isLetterMode = !this.isLetterMode
    },
    handleConfirm () {
      if (this.idCardLastSix.length === 6) {
        this.$router.push({ path: '/SelectedNum' })
      }
    },
    handleExit () {
      this.$confirm({
        title: '确认退出',
        content: '确定要退出系统吗？',
        onOk: () => {
          // 清除登录状态
          this.$store.commit('setIsLoggedIn', false)
          this.$store.commit('setCurrentUser', null)
          // 跳转到登录页
          this.$router.push('/login')
        }
      })
    },
    provinceChange (value) {
      this.$store.state.selectedProvince = value
    },
    specialNumsChange (value) {
      this.$store.state.specialNum = value
    },
    numhange (value) {
      this.$store.state.zimuNum = value
    },
    areaChange (areas) {
      this.selectedAreas = areas
      const newProbabilities = { ...this.areaProbabilities }
      areas.forEach(area => {
        if (!newProbabilities[area]) {
          newProbabilities[area] = 20
        }
      })
      this.areaProbabilities = newProbabilities
      this.$store.commit('updateAreaSettings', {
        areas: this.selectedAreas,
        areaProbabilities: this.areaProbabilities
      })
    },
    handleDoubleClick () {
      this.isShowProvince = !this.isShowProvince
    },
    handleModalOk () {
      const totalProbability = this.letterRules.reduce((sum, rule) => sum + rule.probability, 0)
      if (totalProbability && totalProbability !== 100) {
        this.$message.error('所有规则的概率总和需等于100%')
      } else {
        this.$store.commit('updateAreaSettings', {
          areas: this.selectedAreas,
          areaProbabilities: this.areaProbabilities
        })
        this.isShowProvince = false
        this.$message.success('设置成功')
      }
    },
    handleModalCancel () {
      this.isShowProvince = false
    },
    handleLetterChange () {
      // 处理字母变化
    },
    handlePositionInput (index, value) {
      const newPositions = [...this.currentRule.positions]
      if (value) {
        const upperValue = value.toUpperCase()
        if (/^[A-Z0-9]$/.test(upperValue)) {
          newPositions[index] = upperValue
        }
      } else {
        newPositions[index] = ''
      }
      this.currentRule.positions = newPositions
      this.updateLetterRule()
    },
    handleProbabilityChange (value) {
      this.currentRule.probability = value
      this.updateLetterRule()
    },
    handleTypeChange () {
      this.currentRule.positions = this.currentRule.type === 'new' ? ['', '', '', '', '', ''] : ['', '', '', '', '']
      this.$store.commit('clearLetterRules')
      this.updateLetterRule()
    },
    updateLetterRule () {
      this.$store.commit('updateLetterRule', {
        positions: this.currentRule.positions,
        probability: this.currentRule.probability,
        type: this.currentRule.type
      })
    },
    addRule () {
      if (!this.currentRule.positions.some(pos => pos !== '')) {
        this.$message.warning('请至少设置一个位置的字母')
        return
      }
      const totalProbability = this.letterRules.reduce((sum, rule) => sum + rule.probability, 0) + this.currentRule.probability
      if (totalProbability > 100) {
        this.$message.warning('所有规则的概率总和不能超过100%')
      } else {
        this.$store.commit('addLetterRule')
        this.currentRule.positions = this.currentRule.type === 'new' ? ['', '', '', '', '', ''] : ['', '', '', '', '']
        this.$message.success('规则添加成功')
      }
    },
    removeRule (index) {
      this.$store.commit('removeLetterRule', index)
    },
    handleAreaProbabilityChange (area, value) {
      this.areaProbabilities = {
        ...this.areaProbabilities,
        [area]: value
      }
      this.$store.commit('updateAreaSettings', {
        areas: this.selectedAreas,
        areaProbabilities: this.areaProbabilities
      })
    }
  },
  mounted () {
    const state = this.$store.state
    this.selectedAreas = state.areaSettings.areas || ['A']
    this.areaProbabilities = state.areaSettings.areaProbabilities || { A: 20 }
    this.selectedAreas.forEach(area => {
      if (!this.areaProbabilities[area]) {
        this.areaProbabilities[area] = 20
      }
    })
    this.$store.commit('updateAreaSettings', {
      areas: this.selectedAreas,
      areaProbabilities: this.areaProbabilities
    })
    if (state.letterRules && state.letterRules.length > 0) {
      this.currentRule = { ...state.letterRules[0] }
    }
    if (state.specialNum) {
      this.specialNumsChange(state.specialNum)
    }
    if (state.userName) {
      this.userName = state.userName
    }
    if (state.carBrand) {
      this.carBrand = state.carBrand
    }
    if (state.fixedPlate) {
      this.fixedPlate = state.fixedPlate
    }
    this.$watch('selectedAreas', (newVal) => {
      this.areaChange(newVal)
    })
  }
}
</script>

<style scoped>
.keyboard {
  width: 100%;
  display: flex;
  gap: 0;
  margin-top: 20px;
  flex-direction: column;
  align-items: center;
}

.keyboard-row {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding: 2px;
  border: 1px solid #e5e5e5;
}

.keyboard-row .ant-btn {
  font-size: 30px;
  width: 140px;
  padding: 2px;
  background-color: #eef1f3;
  height: 50px;
  border: 0;
}

.ant-divider-vertical {
  position: relative;
  top: 1px;
  display: inline-block;
  width: 1px;
  height: 55px;
  margin: -3px;
  vertical-align: middle;
  padding: 0;
}

.footer-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 80px;
}

.setting-section {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #1890ff;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 8px;
}
</style>

